import { useRef } from "react";
import { motion, useInView } from "framer-motion";
import "./Contact.css";

export default function Contact() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-8%" });

  return (
    <section className="contact-area pt-100 pb-70" id="contact" ref={ref}>
      <div className="container">
        <div className="row">
          <div className="col-lg-6">
            <motion.div
              className="contact-item contact-left"
              initial={{ opacity: 0, x: -30 }}
              animate={isInView ? { opacity: 1, x: 0 } : { opacity: 0, x: -30 }}
              transition={{ duration: 0.38, ease: [0.25, 0.1, 0.25, 1] }}
            >
              <h3>Start een Gesprek met Kris.</h3>
              <span className="section-badge" style={{ marginBottom: "1.5rem", display: "inline-block" }}>Contact</span>
              <ul>
                <li>
                  <i className="bx bx-location-plus"></i>
                  Herentalse Steenweg 89A, 2280 Grobbendonk
                </li>
                <li>
                  <i className="bx bx-mail-send"></i>
                  <a href="mailto:kris@carrosseriekris.be">
                    kris@carrosseriekris.be
                  </a>
                </li>
                <li>
                  <i className="bx bx-phone-call"></i>
                  <a href="tel:+32497284662"> +32 497 28 46 62 </a>
                </li>
                <li>
                  <i className="bx bx-network-chart"></i>
                  <a href="#"> Eurogarant 909 </a>
                </li>
                <li>
                  <i className="bx bx-file"></i>
                  <a href="#"> BE 0687.810.469 </a>
                </li>
              </ul>
            </motion.div>
          </div>
          <div className="col-lg-6">
            <motion.div
              className="contact-item contact-right"
              initial={{ opacity: 0, x: 30 }}
              animate={isInView ? { opacity: 1, x: 0 } : { opacity: 0, x: 30 }}
              transition={{ duration: 0.38, ease: [0.25, 0.1, 0.25, 1], delay: 0.1 }}
            >
              <form
                id="contactForm"
                action="https://formspree.io/f/mbjwljdb"
                method="POST"
              >
                <div className="row">
                  <div className="col-sm-6 col-lg-6">
                    <div className="form-group">
                      <input
                        type="text"
                        name="name"
                        id="name"
                        className="form-control"
                        required
                        data-error="Geef een geldige naam"
                        placeholder="Naam"
                      />
                      <div className="help-block with-errors"></div>
                    </div>
                  </div>

                  <div className="col-sm-6 col-lg-6">
                    <div className="form-group">
                      <input
                        type="email"
                        name="email"
                        id="email"
                        className="form-control"
                        required
                        data-error="Geef een geldig E-mail adres"
                        placeholder="E-mail"
                      />
                      <div className="help-block with-errors"></div>
                    </div>
                  </div>

                  <div className="col-sm-6 col-lg-6">
                    <div className="form-group">
                      <input
                        type="text"
                        name="phone_number"
                        id="phone_number"
                        required
                        data-error="Geef een geldig telefoon nummer"
                        className="form-control"
                        placeholder="Telefoon nummer"
                      />
                      <div className="help-block with-errors"></div>
                    </div>
                  </div>

                  <div className="col-sm-6 col-lg-6">
                    <div className="form-group">
                      <input
                        type="text"
                        name="subject"
                        id="subject"
                        className="form-control"
                        required
                        data-error="Geef een geldig onderwerp"
                        placeholder="Onderwerp"
                      />
                      <div className="help-block with-errors"></div>
                    </div>
                  </div>

                  <div className="col-md-12 col-lg-12">
                    <div className="form-group">
                      <textarea
                        name="msg"
                        className="form-control"
                        id="msg"
                        cols="30"
                        rows="8"
                        required
                        data-error="Schrijf je bericht"
                        placeholder="Bericht"
                      ></textarea>
                      <div className="help-block with-errors"></div>
                    </div>
                  </div>

                  <div className="col-md-12 col-lg-12">
                    <button type="submit" className="contact-btn btn">
                      Verzend
                    </button>
                    <div className="clearfix"></div>
                  </div>
                </div>
              </form>
              <div id="status"></div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}
